import React from 'react';
import {makeStyles, withStyles, Typography, Grid, Button, Paper, Divider, LinearProgress} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import customAxios from "../../../../API/customAxios";
import {postEditEmployeeApprover} from "../../../EmployeeRecord/api/review";
import {checkUndefined} from '../../../../Function/globalFunction';
import {breakpoints, reviewStyle} from '../../../../UIComponent/CommonStyle';

const useStyles = makeStyles((theme) => ({
    ...reviewStyle(theme),
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: '5px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1, 2, 1),
        [breakpoints.up("md")]: {
            padding: theme.spacing(2, 4, 3),
        }
    },
    loadingBar: {
        width: '99%',
        marginLeft: '3px',
    }
}));

export default function Review(
    {
        handleClose,
        backToTable,
        open,
        showId,
        employeeName,
        firstApproverId,
        secondApproverId,
        firstApproverName,
        secondApproverName,
        updateApprover
    }
) {

    const [showAfterSubmit, setShowAfterSubmit] = React.useState(false);
    const [isError, setError] = React.useState(false);
    const [databaseValues, setDatabaseValues] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(false);

    const classes = useStyles();
    const StyledDivider = withStyles({
        root: {
            background: '#DCDCDC',
            marginTop: 3,
            marginBottom: 3,
            height: 2,
        },
    })(Divider);

    const handleCancel = (event, reason) => {
        if (reason !== 'backdropClick') {
            handleClose();
        }
    };

    React.useEffect(() => {
        customAxios.get(`/get_employee_approver/` + showId)
            .then(res => {
                const getEmployeeApprover = res.data;
                setDatabaseValues({
                    employeeId: `${getEmployeeApprover.id}`,
                    firstApproverName: `${checkUndefined(getEmployeeApprover.approver.first_approver_employee, 'employee_name')}`,
                    secondApproverName: `${checkUndefined(getEmployeeApprover.approver.second_approver_employee, 'employee_name')}`,
                });
            })
    }, []);

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        try {
            setIsLoading(true);
            await postEditEmployeeApprover(firstApproverId, secondApproverId, showId);
            setIsLoading(false);
            updateApprover({showId, firstApproverName, secondApproverName});
            handleClose();
            backToTable();
        } catch (e) {
            setShowAfterSubmit(true);
            setError(true);
            window.setTimeout((() => {
                setShowAfterSubmit(false);
                handleClose();
            }), 3000);
        }
    };

    return (
        <React.Fragment>
            <Modal
                   aria-labelledby="confirmation-modal-title"
                   aria-describedby="confirmation-modal-description"
                   className={classes.modal}
                   open={open}
                   onClose={handleCancel}
                   closeAfterTransition
                   BackdropComponent={Backdrop}
                   BackdropProps={{
                       timeout: 500,
                   }}
            >
                <Fade in={open}>
                    {!showAfterSubmit ?
                        <div>
                            {isLoading && <LinearProgress className={classes.loadingBar}/>}
                            <Paper className={classes.modalPaper} style={{width: 600}}>
                                <Typography variant="h6" color="primary" className={classes.title}>
                                    Edit Summary
                                </Typography>
                                <StyledDivider/>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography className={classes.subtitle}>Please confirm the below
                                            information</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography className={classes.subtitle}>Name:</Typography>
                                        <Typography className={classes.subtitle}>First Approver:</Typography>
                                        <Typography className={classes.subtitle}>Second Approver:</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography className={classes.subtitle}>{employeeName}</Typography>
                                        <Typography
                                            className={classes.subtitle}>{databaseValues.firstApproverName} → {firstApproverName}</Typography>
                                        <Typography
                                            className={classes.subtitle}>{databaseValues.secondApproverName} → {secondApproverName}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className={classes.buttonDiv}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                onClick={handleSubmit}
                                                disabled={isLoading}
                                                className={classes.submitButton}
                                            >
                                                Confirm
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="secondary"
                                                onClick={handleCancel}
                                                disabled={isLoading}
                                                className={classes.submitButton}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </div>
                        :
                        <Paper className={classes.afterSubmitPage}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {!isError ? <Typography className={classes.title}>Edit Successful</Typography> :
                                        <Typography className={classes.title}>An error occurred, please try again
                                            later.</Typography>}
                                </Grid>
                                <Grid item xs={12}>
                                    {!isError ? <CheckCircleIcon style={{fontSize: '100px', color: 'green'}}/> :
                                        <CancelIcon color="secondary" style={{fontSize: '100px'}}/>}
                                </Grid>
                            </Grid>
                        </Paper>
                    }
                </Fade>
            </Modal>
        </React.Fragment>
    );
}
